export default __webpack_public_path__ + "static/media/slide_hacemos_mobile.fe0373f2.png";